import useRudderStackTrack from 'hooks/useRudderStackTrack';
import { useCallback } from 'react';
import { ComponentTrackingParams } from '../types';

export const useTrackComponentEvent = () => {
  const rudderTrack = useRudderStackTrack();

  return useCallback(
    ({ event_name, component_type, object, context, object_properties = {} }: ComponentTrackingParams) => {
      const eventName = event_name;

      const properties = {
        component_type,
        object,
        context,
        object_properties: JSON.stringify(object_properties),
      };

      rudderTrack(eventName, properties);
    },
    [rudderTrack]
  );
};
